/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { estimationSchema } from './estimationSchema';

export const estimationSchemeSchema = z.object({
  archivedAt: z.iso.datetime().nullish(),
  createdAt: z.iso.datetime(),
  createdBy: z.string(),
  description: z.string().nullish(),
  get estimations() {
    return z.array(estimationSchema);
  },
  id: z.int(),
  isOrganizationDefault: z.boolean(),
  name: z.string(),
  organizationId: z.string(),
  priority: z.string(),
  updatedAt: z.iso.datetime(),
  updatedBy: z.string(),
});
